



import React, { useEffect, useState } from 'react';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { useNavigate } from 'react-router-dom';
import OverlayLoader from '../../../../components/Common/OverlayLoader';
import { toast } from 'react-toastify';

const PersonalInfo = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const [student, setStudent] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    date_of_birth: '',
    age: '',
    higher_education: '',
    about: '',
    address: '',
    linkedin_link: '',
    skills: '',
    parent_mobile_no: '',
    profile_pic: '',
    headline: '' // 🔹 new field added
  });

  // 🔹 Fetch data once on mount
  useEffect(() => {
    callAPI('get', 'student/get-student-profile-data');
  }, []);

  // 🔹 Set student data after successful fetch
  useEffect(() => {
    if (statusCode === 200 && responce?.data?.student) {
      const fetched = responce.data.student;

      setStudent((prev) => ({
        ...prev,
        first_name: fetched.first_name || '',
        last_name: fetched.last_name || '',
        email: fetched.email || '',
        mobile_no: fetched.mobile_no || '',
        date_of_birth: fetched.date_of_birth || '',
        age: fetched.age || '',
        higher_education: fetched.higher_education || '',
        about: fetched.about || '',
        address: fetched.address || '',
        linkedin_link: fetched.linkedin_link || '',
        skills: fetched.skills || '',
        parent_mobile_no: fetched.parent_mobile_no || '',
        headline: fetched.headline || '', // 🔹 prefill headline if available
        profile_pic: ''
      }));
    }
  }, [responce, statusCode]);

  const handleStudentChange = (e) => {
    setStudent({ ...student, [e.target.name]: e.target.value });
  };

  const updatestudentinfo = (e) => {
    e.preventDefault();
     const formData = new FormData();

  // Append all fields except the image
  for (let key in student) {
    if (key !== 'profile_pic') {
      formData.append(key, student[key]);
    }
  }

  // Append image file if selected
  if (student.profile_pic) {
    formData.append('profile_pic', student.profile_pic);
  }

  callAPI('post', 'student/update-student-profile-data', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
    // callAPI('post', 'student/update-student-profile-data', student);
  };

useEffect(() => {
  if (statusCode === 201 || statusCode === 202) {
    toast.success("Profile updated successfully!");
    setTimeout(() => {
      navigate('/student/profile');
    }, 1000); // wait for the toast to show
  }
}, [statusCode, navigate]);

  return (
    <div className="card p-4 shadow-sm">
      <OverlayLoader show={loading} />
      <h5 className="mb-3">Personal Information</h5>
      <form onSubmit={updatestudentinfo}>
        <div className="row g-3">
          <div className="col-md-4">
            <label>First Name</label>
            <input type="text" name="first_name" value={student.first_name} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Last Name</label>
            <input type="text" name="last_name" value={student.last_name} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Email</label>
            <input type="email" name="email" value={student.email} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Mobile No</label>
            <input type="text" name="mobile_no" value={student.mobile_no} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Parent Mobile No</label>
            <input type="text" name="parent_mobile_no" value={student.parent_mobile_no} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Date of Birth</label>
            <input type="date" name="date_of_birth" value={student.date_of_birth} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Age</label>
            <input type="text" name="age" value={student.age} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Higher Education</label>
            <input type="text" name="higher_education" value={student.higher_education} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>LinkedIn</label>
            <input type="text" name="linkedin_link" value={student.linkedin_link} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Skills</label>
            <input type="text" name="skills" value={student.skills} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Headline</label>
            <input type="text" name="headline" value={student.headline} onChange={handleStudentChange} className="form-control" />
          </div>
          <div className="col-md-8">
            <label>About</label>
            <textarea name="about" value={student.about} onChange={handleStudentChange} className="form-control" rows="2" />
          </div>
          <div className="col-md-4">
            <label>Profile Picture</label>
         <input
  type="file"
  name="profile_pic"
  accept="image/*"
  className="form-control"
  onChange={(e) =>
    setStudent({ ...student, profile_pic: e.target.files[0] })
  }
/>

          </div>
          <div className="col-md-8">
            <label>Address</label>
            <textarea name="address" value={student.address} onChange={handleStudentChange} className="form-control" rows="2" />
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-primary mt-3">Update</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PersonalInfo;


// import React, { useEffect, useState } from 'react';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// import { useNavigate } from 'react-router-dom';
// import OverlayLoader from '../../../../components/Common/OverlayLoader';
// import { toast } from 'react-toastify'; // ✅ Add toast import
// const PersonalInfo = () => {
//   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
//   const navigate = useNavigate();
//   const [student, setStudent] = useState({
//     first_name: '',
//     last_name: '',
//     email: '',
//     mobile_no: '',
//     date_of_birth: '',
//     age: '',
//     higher_education: '',
//     about: '',
//     address: '',
//     linkedin_link: '',
//     skills: '',
//     parent_mobile_no: '',
//     profile_pic: '',
//     headline: ''
//   });
//   useEffect(() => {
//     callAPI('get', 'student/get-student-profile-data');
//   }, []);
//   useEffect(() => {
//     if (statusCode === 200 && responce?.data?.student) {
//       const fetched = responce.data.student;
//       setStudent((prev) => ({
//         ...prev,
//         first_name: fetched.first_name || '',
//         last_name: fetched.last_name || '',
//         email: fetched.email || '',
//         mobile_no: fetched.mobile_no || '',
//         date_of_birth: fetched.date_of_birth || '',
//         age: fetched.age || '',
//         higher_education: fetched.higher_education || '',
//         about: fetched.about || '',
//         address: fetched.address || '',
//         linkedin_link: fetched.linkedin_link || '',
//         skills: fetched.skills || '',
//         parent_mobile_no: fetched.parent_mobile_no || '',
//         headline: fetched.headline || '',
//         profile_pic: ''
//       }));
//     }
//   }, [responce, statusCode]);
//   const handleStudentChange = (e) => {
//     setStudent({ ...student, [e.target.name]: e.target.value });
//   };
//   const updatestudentinfo = (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     for (let key in student) {
//       if (key !== 'profile_pic') {
//         formData.append(key, student[key]);
//       }
//     }
//     if (student.profile_pic) {
//       formData.append('profile_pic', student.profile_pic);
//     }
//     callAPI('post', 'student/update-student-profile-data', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//   };
//   useEffect(() => {
//     if (statusCode === 201 || statusCode === 202) {
//       toast.success("✅ Profile updated successfully!", {
//         autoClose: 1000,
//       });
//       setTimeout(() => {
//         navigate('/student/profile');
//       }, 1000);
//     }
//   }, [statusCode, navigate]);
//   return (
//     <div className="card p-4 shadow-sm">
//       <OverlayLoader show={loading} />
//       <h5 className="mb-3">Personal Information</h5>
//       <form onSubmit={updatestudentinfo}>
//         <div className="row g-3">
//           {/* [ form fields remain unchanged ] */}
//           <div className="col-md-4">
//             <label>First Name</label>
//             <input type="text" name="first_name" value={student.first_name} onChange={handleStudentChange} className="form-control" />
//           </div>
//           {/* ... (other inputs remain unchanged) ... */}
//           <div className="col-md-4">
//             <label>Profile Picture</label>
//             <input
//               type="file"
//               name="profile_pic"
//               accept="image/*"
//               className="form-control"
//               onChange={(e) => setStudent({ ...student, profile_pic: e.target.files[0] })}
//             />
//           </div>
//           {/* ... (more fields) ... */}
//           <div className="col-12">
//             <button type="submit" className="btn btn-primary mt-3">Update</button>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };
// export default PersonalInfo;